import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '@/store'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 600000
})
// 请求拦截
service.interceptors.request.use(
    (config) => {
        if (config.requestBase === 'VUE_APP_URL') {
            config.baseURL = process.env.VUE_APP_URL
        } else if (config.requestBase === 'VUE_APP_URL_TWO') {
            config.baseURL = process.env.VUE_APP_BASE_API
        }
        config.responseType = config.responseType ? config.responseType : 'json'
        // 在这个位置需要统一的去注入token
        if (store.getters.token) {
            // 主动检查登录是否过期
            // if (isCheckTimeOut()) {
            //     // 登出操作
            //     store.dispatch('user/logout')
            //     return Promise.reject(new Error('token 失效！'))
            // }
            // 如果token存在 注入token
            config.headers.Authorization = `Bearer ${store.getters.token}`
        }
        return config // 必须返回配置
    },
    (error) => {
        return Promise.reject(error)
    }
)
let status = true
// 响应拦截器
service.interceptors.response.use(
    // 请求成功
    (response) => {
        const { code, msg, data } = response.data
        // 需要判断当前请求是否成功
        if (code === 0) {
            // 成功，返回解析后的数据
            if (response.request.responseURL.indexOf('/imports') > -1) {
                return response.data
            }
            // 导出
            if (response.config.params?.export) {
                return response.data
            }
            return data
        } else if (code === 401) {
            store.dispatch('user/logout')
        } else {
            // 失败（请求成功，业务失败）
            if (response.request.responseURL.indexOf('/imports') > -1 || response.request.responseURL.indexOf('/snapshot') > -1) {
                return response.data
            }
            // 导出
            if (response.config.params?.export) {
                return response.data
            }
            showMessage(msg)
            return Promise.reject(new Error(msg))
        }
    },
    // 请求失败
    (error) => {
        // 处理 token 超时问题
        if (error.response && error.response.data && error.response.data.code === 401) {
            // token超时
            store.dispatch('user/logout')
        }
        // 失败（请求成功，业务失败）
        if (error.request.responseURL.indexOf('/imports') > -1) {
            const { msg, data } = JSON.parse(error.request.response)
            let str = ''
            if (data && data?.length) {
                str = msg + ' <br /> '
                data.forEach((ele) => {
                    str += '第' + ele.err_no + '行：' + ele.err_msg + ' <br /> '
                })
            } else {
                str = msg
            }

            showMessage(str)
            return Promise.reject(new Error(error))
        }
        if (error.request.responseURL.indexOf('/snapshot') > -1) {
            return Promise.reject(new Error(error))
        }
        showMessage(error.response.data.msg)
        return Promise.reject(new Error(error))
    }
)

function showMessage(msg) {
    if (status) {
        status = false
        ElMessage.error({
            type: 'error',
            dangerouslyUseHTMLString: true,
            message: msg
        })
        const timeout = setTimeout(() => {
            status = true
            clearTimeout(timeout)
        }, 1500)
    }
}

export default service
